var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'profile-avatar': _vm.squared,
    'mate-profile': !_vm.squared,
    rounded: !_vm.pic,
  },style:(("height: " + _vm.size + "px; width: " + _vm.size + "px")),attrs:{"title":_vm.name}},[(_vm.pic)?_c('img',{class:_vm.squared ? 'avatar-img' : 'mate-img',attrs:{"src":_vm.url,"alt":_vm.name}}):_c('div',[_vm._v("\n    "+_vm._s(_vm.initials)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }